module.exports = __webpack_public_path__ + "img/OIP-C.701eace0.jpg";